import { ICockpitCategoryOption, IPartnerFinSobRow } from '../../model/types'

import { OVERALL_CATEGORY } from './constants'

/** The distinct product categories present in `rows`, excluding the `OVERALL_CATEGORY` sentinel —
 *  ordered by `categoryOrder` (ascending `order`, alphabetical tie-break — same comparator as
 *  `getCockpitCategoriesByOffering`), with any category missing from `categoryOrder` appended
 *  afterwards in first-appearance order. */
export const getFinSobCategories = (
  rows: IPartnerFinSobRow[],
  categoryOrder: ICockpitCategoryOption[] = []
): string[] => {
  const categories: string[] = []

  for (const row of rows) {
    if (row.category !== OVERALL_CATEGORY && !categories.includes(row.category)) {
      categories.push(row.category)
    }
  }

  const orderByCategory = new Map(categoryOrder.map(({ category, order }) => [category, order]))

  const ordered = categories
    .filter((category) => orderByCategory.has(category))
    .sort(
      (left, right) =>
        orderByCategory.get(left)! - orderByCategory.get(right)! || left.localeCompare(right)
    )
  const unordered = categories.filter((category) => !orderByCategory.has(category))

  return [...ordered, ...unordered]
}
